import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FiMapPin } from 'react-icons/fi';
import { formatDisplayShort } from '../../../lib/dateUtils';
import Button from '../../../components/ui/Button';
import SiteStatusBadge from './SiteStatusBadge';
import SiteSessionAction from './SiteSessionAction';

/**
 * Controlled mobile site cards. All state and data fetching stay in the parent
 * (Sites.jsx); this component only renders cards. The card body links to site
 * details; action buttons (Edit / Resume) sit outside that Link.
 */
export default function SiteMobileCards({
  filteredSites,
  inProgressBySite,
  defectCountBySiteId,
  dueThisMonthIds,
  showUpcomingDivider,
  hasSites,
  onEdit,
}) {
  return (
    <div className="sites-mobile-cards">
      {(() => {
        let upcomingDividerRendered = false;
        return filteredSites?.map((site) => {
          const addressDisplay =
            [site.address, site.city, site.state, site.postcode].filter(Boolean).join(', ') || '—';
          const inProgressSessionsForSite = inProgressBySite.get(Number(site.id)) ?? [];
          const meta = defectCountBySiteId.get(String(site.id));
          const isDueThisMonth = dueThisMonthIds.has(site.id);
          const renderDivider = showUpcomingDivider && !isDueThisMonth && !upcomingDividerRendered;
          if (renderDivider) upcomingDividerRendered = true;
          return (
            <Fragment key={site.id}>
              {renderDivider && (
                <div className="site-filter-divider-mobile" aria-hidden="true">Upcoming</div>
              )}
              <div className="site-mobile-card">
                <Link
                  to={`/sites/${site.id}`}
                  className="site-mobile-card-link"
                  style={{ display: 'block' }}
                >
                  <div className="site-mobile-card-name">
                    {site.display_name ?? site.name?.trim() ?? site.site_code ?? 'Unnamed site'}
                  </div>
                  <div style={{ marginTop: '0.25rem' }}>
                    <SiteStatusBadge
                      count={meta?.count ?? 0}
                      isLoading={meta?.isLoading ?? true}
                      isError={meta?.isError ?? false}
                    />
                  </div>
                  <div className="site-mobile-card-address">
                    <FiMapPin aria-hidden />
                    {addressDisplay}
                  </div>
                  <div className="site-mobile-card-address" style={{ marginTop: '0.25rem' }}>
                    Next test due: {site.next_test_due_date ? formatDisplayShort(site.next_test_due_date) : '—'}
                  </div>
                </Link>
                {(onEdit || inProgressSessionsForSite.length > 0) && (
                  <div className="site-mobile-card-actions">
                    {onEdit && (
                      <Button
                        type="button"
                        size="sm"
                        variant="secondary"
                        className="site-mobile-btn-edit"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); onEdit(site); }}
                      >
                        Edit
                      </Button>
                    )}
                    {inProgressSessionsForSite.map((s) => (
                      <SiteSessionAction key={s.id} session={s} siteId={site.id} />
                    ))}
                  </div>
                )}
              </div>
            </Fragment>
          );
        });
      })()}
      {!hasSites && (
        <p className="empty-state">No sites yet. Add your first site to get started.</p>
      )}
    </div>
  );
}
